var path = '/app/components/search/search-manage-presets-container.component.html';
var html = "<div style=\"padding:20px\" class=\"search-form\"> <search-manage-presets kendo=\"$ctrl.kendo\" selected-dealer-id=\"$ctrl.dealerId\" current-view=\"Manage\"></search-manage-presets> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;